<template>
    <div class="dept-container">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                class="search-form"
                :model="search_data"
                label-position="top"
                style="padding: 0 20px"
            >
                <el-form-item label="操作人员">
                    <el-input v-model="search_data.username" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="操作地址">
                    <el-input v-model="search_data.ip" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search_data.status" clearable placeholder="请选择" style="width: 150px">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="操作信息">
                    <el-input v-model="search_data.wd" clearable placeholder="操作信息" style="width: 150px" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <div class="circle-btn">
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            :content="formVisible ? '隐藏搜索' : '显示搜索'"
                            placement="top"
                        >
                            <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="刷新" placement="top">
                            <el-button plain circle @click="getTableData" :icon="Refresh" size="small"></el-button>
                        </el-tooltip>
                    </div>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%">
                <el-table-column prop="action" label="操作类型"></el-table-column>
                <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
                <el-table-column prop="ip" label="操作地址"></el-table-column>
                <el-table-column prop="status" label="操作状态" width="100">
                    <template #default="{ row }">
                        <el-tag v-if="row.status">成功</el-tag>
                        <el-tag type="danger" v-else>失败</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="desc" label="操作信息"></el-table-column>
                <el-table-column prop="create_time" label="操作日期" sortable width="180"></el-table-column>
                <el-table-column
                    prop="cost_time"
                    label="消耗时间"
                    :formatter="
                        (row, column, cellValue, index) => {
                            return cellValue + '毫秒'
                        }
                    "
                    width="100"
                ></el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            :icon="View"
                            @click="onShowDetail(row)"
                            v-permission="['base:operlog:view']"
                        >
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>
        <OperlogDetail v-model="detailVisible" :dialogData="dialogData" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getOperationLogList } from '@/api/log.js'
import { Refresh, Search, View } from '@element-plus/icons'
import OperlogDetail from './components/OperlogDetail.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
// ElMessage
const detailVisible = ref(false)
const dialogData = ref({})
// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
const search_data = ref({
    username: '',
    ip: '',
    status: '',
    ed: ''
})
const statusOptions = [
    { label: '成功', value: 1 },
    { label: '失败', value: 0 }
]
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)
// 获取数据的方法
const getTableData = async () => {
    const result = await getOperationLogList({
        page: page.value,
        page_size: size.value,
        ...search_data.value,
        ...route.query
    })
    table_data.value = result.lists
    total.value = result.total
}
const onShowDetail = (row) => {
    dialogData.value = row
    detailVisible.value = true
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped></style>
